// Header component via global vue insterface:
import { header } from './vue'
header()

// Alpine.js
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

// Barba.js
require('./barba')

// if window scroll is more than 10px add class to header element
window.onscroll = function() {
	if (window.scrollY > 1) {
		document.body.classList.add('scrolled')
	} else {
		document.body.classList.remove('scrolled')
	}
}
